// import { useCallContext } from '@gem/call/CallView/CallView.context';
// import { AddCallMembersPopup } from '@gem/call/popups/AddCallMembersPopup/AddCallMembersPopup';
import { FC } from 'react';

import { IcAddUserIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
// import { popupsTasks } from '@gem/popups';
import { IconView } from '@gem/ui-kit';

import styles from './AddPeopleLink.styles.m.css';

interface IAddPeopleLinkProps {
  groupId: string;
}

export const AddPeopleLink: FC<IAddPeopleLinkProps> = (_props) => {
  const { t } = useTranslation();
  // const context = useCallContext();
  const onClick = (): void => {
    // popupsTasks.openPopup(AddCallMembersPopup, {
    //   params: {
    //     groupId: props.groupId,
    //     call: context.call,
    //   },
    // });
  };

  return (
    <button
      onClick={onClick}
      className={styles.link}
    >
      <IconView
        Icon={IcAddUserIcon}
        className={styles.icon}
      />
      <span className={styles.title}>{t('common_add_people')}</span>
    </button>
  );
};
